// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CloudInventoryProviderSchema } from '../inputTypeSchemas/CloudInventoryProviderSchema'
import { CloudInventoryAccountStatusSchema } from '../inputTypeSchemas/CloudInventoryAccountStatusSchema'

/////////////////////////////////////////
// CLOUD INVENTORY ACCOUNT SCHEMA
/////////////////////////////////////////

export const CloudInventoryAccountSchema = z.object({
  provider: CloudInventoryProviderSchema,
  status: CloudInventoryAccountStatusSchema,
  id: z.string(),
  tenantId: z.string(),
  accountRef: z.string(),
  displayName: z.string(),
  parentAccountRef: z.string().nullable(),
  lastSyncedAt: z.coerce.date().nullable(),
  lastError: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CloudInventoryAccount = z.infer<typeof CloudInventoryAccountSchema>

export default CloudInventoryAccountSchema;
